import { useEffect } from 'react'
import { appStore } from '@/store/app'

export function useAutosave(intervalMs = 30000) {
	useEffect(() => {
		if (intervalMs <= 0) return
		let busy = false
		const id = window.setInterval(() => {
			const s = appStore.snapshot()
			const onAccount = window.location.pathname.startsWith('/account')
			const canAutosave = !!s.user && s.user.application_process === 'Draft' && onAccount
			if (!canAutosave) return
			if (!busy && s.dirty && !s.saving) {
				busy = true
				appStore
					.save({ source: 'autosave' })
					.catch(() => {
						// Failure feedback is handled inside appStore.save; the edits
						// stay dirty and the next tick retries.
					})
					.finally(() => {
						busy = false
					})
			}
		}, intervalMs)
		return () => window.clearInterval(id)
	}, [intervalMs])
}
